/* eslint-disable @typescript-eslint/explicit-member-accessibility */

import type { ErrorInfo } from 'react'
import React from 'react'

type Props = {
  fallback?: React.ReactNode
  children: React.ReactNode
}

type State = {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const URLError = window?.location?.href
    const date = new Date()
    const dateNow = date?.toISOString()

    window.appInsights.trackException(error, {
      ...errorInfo,
      date: dateNow,
      url: URLError,
    })
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null
    }

    return this.props.children
  }
}
